import { Operator } from './flow/types';

const isEqualTo: Operator = {
  label: 'is equal to',
  value: '==',
  isValuable: true,
};

const isNotEqualTo: Operator = {
  label: 'is not equal to',
  value: '!=',
  isValuable: true,
};

const isNull: Operator = {
  label: 'is empty',
  value: '== null',
  isValuable: false,
};

const isNotNull: Operator = {
  label: 'is not empty',
  value: '!= null',
  isValuable: false,
};

const isLessThan: Operator = {
  label: 'is less than',
  value: '<',
  isValuable: true,
};

const isBiggerThan: Operator = {
  label: 'is bigger than',
  value: '>',
  isValuable: true,
};

export default [isEqualTo, isNotEqualTo, isNotNull, isNull, isLessThan, isBiggerThan];
